module.exports = __webpack_public_path__ + "img/seq6.3656df9a.png";